import { ERP_THEME_VALUES } from './antd-theme-values.js';

const { colors, radius, steps } = ERP_THEME_VALUES;

const formControlFocusTokens = {
  activeBorderColor: colors.secondary,
  hoverBorderColor: colors.buttonPrimaryHover,
  activeShadow: '0 0 0 2px rgba(35, 178, 124, 0.2)',
};

const selectFocusTokens = {
  ...formControlFocusTokens,
  activeOutlineColor: 'rgba(35, 178, 124, 0.2)',
};

export const antdThemeTokens = {
  token: {
    colorPrimary: colors.primary,
    colorPrimaryHover: colors.primaryHover,
    colorPrimaryActive: colors.primaryActive,
    colorLink: colors.primary,
    colorLinkHover: colors.primaryHover,
    colorLinkActive: colors.primaryActive,
    colorError: colors.error,
    colorSuccess: colors.secondary,
    colorBorder: colors.borderLight,
    colorBgContainerDisabled: colors.disabledBg,
    colorTextDisabled: colors.disabledText,
    borderRadius: radius.base,
    borderRadiusSM: radius.small,
  },
  components: {
    Alert: {
      colorInfoBg: colors.lightBlue,
    },
    Button: {
      colorPrimary: colors.secondary,
      colorPrimaryHover: colors.buttonPrimaryHover,
      colorPrimaryActive: colors.secondaryActive,
      colorError: colors.error,
      colorErrorHover: colors.primaryHover,
      colorErrorActive: colors.primaryActive,
      colorErrorBorderHover: colors.primaryHover,
      primaryColor: '#fff',
      dangerColor: '#fff',
      borderRadiusSM: radius.buttonSmall,
    },
    Checkbox: {
      borderRadiusSM: radius.checkbox,
    },
    Collapse: {
      borderRadiusLG: radius.panel,
      headerBg: '#fff',
    },
    Descriptions: {
      itemPaddingBottom: 16,
      labelColor: 'rgba(0, 0, 0, .85)',
    },
    DatePicker: {
      colorPrimary: colors.secondary,
      colorPrimaryHover: colors.buttonPrimaryHover,
      activeBorderColor: colors.secondary,
      hoverBorderColor: colors.buttonPrimaryHover,
      activeShadow: formControlFocusTokens.activeShadow,
    },
    Input: formControlFocusTokens,
    InputNumber: formControlFocusTokens,
    Mentions: formControlFocusTokens,
    Menu: {
      itemActiveBg: colors.menuActiveBg,
      itemSelectedColor: colors.disabledText,
      subMenuItemBg: '#fff',
    },
    Radio: {
      buttonCheckedBg: colors.secondary,
    },
    Select: selectFocusTokens,
    Steps: {
      colorPrimary: colors.secondary,
      colorSplit: colors.borderLight,
      customIconFontSize: steps.customIconFontSize,
      customIconSize: steps.customIconSize,
      customIconTop: steps.customIconTop,
      iconFontSize: steps.iconFontSize,
      iconSize: steps.iconSize,
      iconTop: steps.iconTop,
    },
    Table: {
      borderRadius: radius.table,
    },
    Tabs: {
      inkBarColor: colors.lightGray,
    },
    TreeSelect: selectFocusTokens,
  },
};
